import styled from 'styled-components';
import { IonMenu } from '@ionic/react';

import { configs } from '$configs';
import { Div, FONT, SPACE, WEIGHT } from '$gstyles';
import { ellipsis } from '$gstyles/mixins';

export const Wrapper = styled(IonMenu)`
  @media screen and (min-width: ${configs.display.desktopMinThreshold}) {
    --side-max-width: 250px;
    --side-min-width: 250px;
  }
  border-width: 0px;

  ion-content {
    --background: #f6f6f6;
  }

  .user-name {
    margin-left: ${SPACE.SMALL};
    font-weight: ${WEIGHT.SEMI_BOLD};
  }
  .item-count {
    height: 44px;
    color: var(--ion-color-primary);
    background-color: var(--ion-color-light);
  }

  .cancel-button {
    background-color: #f6f6f6;
  }

  .clear-cart {
    font-size: ${FONT.XSMALL};
    color: var(--ion-color-secondary);
    .MuiSvgIcon-root {
      font-size: ${FONT.LARGE};
    }
  }

  ion-footer {
    button {
      border-radius: 0%;
      font-size: ${FONT.MEDIUM};
      padding: 24px ${SPACE.LARGE};
    }
  }

  .instruction {
    width: 144px;
  }
`;

export const CartListWrapper = styled(Div)`
  padding: ${SPACE.LARGE};

  .cart-item {
    justify-content: space-between;
    align-items: flex-start;
    min-height: 44px;
    margin-bottom: ${SPACE.MEDIUM};

    &.header {
      font-weight: ${WEIGHT.SEMI_BOLD};
    }
    &.with-mod {
      min-height: 50px;
    }
    .item-text {
      line-height: 14px;
      padding-right: ${SPACE.SMALL};
    }
    .instruction {
      ${ellipsis}
      font-size: 0.85em;
      opacity: 0.8;
    }
    .name {
      font-size: 1em;
      color: #000;
    }
    .mod {
      opacity: 0.8;
      font-size: 0.8em;
    }
    .price {
      opacity: 0.8;
      font-size: 0.85em;
    }
    .quantity {
      min-width: 44px;
      text-align: right;
    }
  }
  .MuiOutlinedInput-inputMarginDense {
    padding-top: 7px;
    padding-bottom: 7px;
  }
`;

export const OrderSummaryWrapper = styled(Div)`
  padding: ${SPACE.LARGE};

  .title {
    font-weight: ${WEIGHT.SEMI_BOLD};
    font-size: ${FONT.MEDIUM};
    padding: ${SPACE.MEDIUM} ${SPACE.MEDIUM};
  }
  .box {
    padding: ${SPACE.MEDIUM};
    background-color: #f1f1f1;
    .line {
      display: flex;
      justify-content: space-between;
      font-weight: ${WEIGHT.SEMI_BOLD};
      font-size: ${FONT.SMALL};
      height: 24px;
    }
    .line.total {
      font-size: 1.1em;
      color: var(--ion-color-primary);
    }
  }
`;
